import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { htmlUrls } from '@shared/utils/router-paths';
import { Router, RouterModule } from '@angular/router';
import { SharedModule } from '@shared/module/shared.module';
import { MergeService } from '@app/pages/merge/service/merge.service';
import { IMergeItem } from '@app/pages/merge/model/merge-item.interface';
import { EImageType } from '@shared/pipes/image.pipe';
import { finalize, tap } from 'rxjs';
import { MergeBooksAggrService } from '@shared/service/http_services/Aggrigators/merge-book-aggrigator.service';
import { SnackbarService } from '@shared/utils/snackbar.service';
import { SnackBarTypes } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';


@Component({
  selector: 'app-merge-list',
  templateUrl: './selected-merge-list.component.html',
  styleUrls: ['./selected-merge-list.component.scss'],
  imports: [
    RouterModule,
    SharedModule,
    CommonModule,
  ]
})
export class SelectedMergeListComponent implements OnInit {
  private router = inject(Router);
  dialog = inject(MatDialog);
  private mergeService = inject(MergeService);
  private mergeBooksAggrService = inject(MergeBooksAggrService);
  private snackbarService = inject(SnackbarService);
   
  private _location = inject(Location);

  mergeAuthorsList: IMergeItem[] = [];
  mergePublisherList: IMergeItem[] = [];
  mergeBookList: IMergeItem[] = [];
  isLoading = false;

  routes = htmlUrls;

  imageType = EImageType

  constructor() {
    this.mergeAuthorsList = this.mergeService.GetAuthorsMergeList;
    this.mergeBookList = this.mergeService.GetBookMergeList;
  }

  ngOnInit(): void {
    this.mergeService.selectedAuthorToMerge?.subscribe(res => {
      if (res) {
        this.mergeAuthorsList = res;
      }
    });

    this.mergeService.selectedPublisherToMerge?.subscribe(res => {
      if (res) {
        this.mergePublisherList = res;
      }
    });

    this.mergeService.selectedBookToMerge?.subscribe(res => {
      if (res) {
        this.mergeBookList = res;
      }
    })
  }

  removeItem(item: IMergeItem) {
    this.mergeService.RemoveMergeItem(item.id, item.type);
    if (!(this.mergeAuthorsList?.length > 0 || this.mergePublisherList?.length > 0 || this.mergeBookList?.length > 0)) {
      this.dialog.closeAll();
    }
  }

  gotoMerge() {
    this.isLoading = true;
    if (this.mergeBookList?.length > 0) {
      this.checkBookConvert().subscribe()
    } else {
      this.router.navigate([this.routes.merge]);
      this.isLoading = false;
      this.dialog.closeAll();
    }
  }


  checkBookConvert() {
    const bookIds: string[] = [];
    this.mergeBookList.forEach(item => {
      bookIds.push(item.id)
    });

    return this.mergeBooksAggrService.compareSeveralBook(bookIds).pipe(
      tap(res => {
        if (res?.result?.length < 1 || res?.hasError) {
          this.snackbarService.openSnackbar(SnackBarTypes.error, 'مشکلی رخ داده است. لطفاً کمی بعد، مجدد درخواست کنید.' );
          this.dialog.closeAll();
        } else {
          const secondBookId = bookIds[1];
          const secondBookInResult = res?.result.find(item => item?.bookId === secondBookId);

          if (secondBookInResult?.hasDependency) {
            this.snackbarService.openSnackbar(SnackBarTypes.error, 'این کتاب قابل تلفیق کردن نیست.' );
            this.dialog.closeAll();
          } else {
            this.router.navigate([this.routes.merge], { state: { bookData: res?.result } });
            this.dialog.closeAll();
          }
        }
      }),
      finalize(() => this.isLoading = false)
    )
  }

  get mergeTitle(): string {
    if (this.mergePublisherList?.length > 0) {
      return "ناشر";
    } else if (this.mergeAuthorsList?.length > 0) {
      return "نویسنده";
    } else if (this.mergeBookList?.length > 0) {
      return "کتاب";
    }
    else return '';
  }
}
